import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { localize } from 'vee-validate'

Vue.use(VueI18n)

// get language default
const languageDefault = localStorage.getItem('locale')

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

localize(languageDefault || process.env.VUE_APP_LOCALE)
export default new VueI18n({
  locale: languageDefault || process.env.VUE_APP_LOCALE,
  fallbackLocale: languageDefault || process.env.VUE_APP_LOCALE,
  messages: loadLocaleMessages(),
  silentTranslationWarn: process.env.NODE_ENV === 'production',
})
